import React, { ReactElement } from 'react';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';


// Constants

import { DROPDOWN_OPTIONS } from '@constants/ssap/hhmTypes/dropdownOptions';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';

// Types

import { IsState, SsapData } from '../../../SsapTypes';

interface INumberOfYearsAttestation {
    actions: {
        onFieldChange_finConsent: Function,
    },
    data: SsapData,
    exchangeName: string,
    isAsteriskShown: boolean,
    isFinancialFlow: boolean,
    isState: IsState,
    formName: string
}

const NumberOfYearsAttestation = (props: INumberOfYearsAttestation): ReactElement => {
    const {
        actions: {
            onFieldChange_finConsent
        },
        data,
        data: {
            numberOfYearsAgreed
        },
        exchangeName,
        isAsteriskShown = true,
        isFinancialFlow,
        isState,
        formName
    } = props;

    return (
        <UniversalInput
            legend = { {
                legendText: isFinancialFlow
                    ? 'ssap.input.legend.term_of_renewals'
                    : 'ssap.input.legend.permission_to_renew',
                legendTextReplacements: {
                    exchangeName
                },
                parseLegend: isState.IL || isState.NM || isState.PA
            }}
            label = { {
                showRequiredIcon: isAsteriskShown
            } }
            inputData = { {
                isInputRequired: true,
                type: INPUT_TYPES.RADIO_BUTTONS,
                name: 'numberOfYearsAgreed',
                value: numberOfYearsAgreed,
                options: isFinancialFlow
                    ? DROPDOWN_OPTIONS.NUMBER_OF_YEARS_FINANCIAL_FLOW
                    : DROPDOWN_OPTIONS.NUMBER_OF_YEARS_NON_FINANCIAL_FLOW,
                optionsReplacements: { exchangeName },
                validationType: VALIDATION_TYPES.CHOSEN,
                currentData: data,
                fields: [ ]
            }}
            inputActions = { {
                onFieldChange: onFieldChange_finConsent
            } }
            underFormControl
            parentForm = { { name: formName } }
            errorClasses = { [ 'margin-l-0' ] }
        />
    );
};

export default NumberOfYearsAttestation;